/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { CopyModal, ConfirmModal, FooterlessModal } from './context/index';

export const modals = {
  footerless: FooterlessModal,
  copy: CopyModal,
  confirm: ConfirmModal,
  /* ...other modals */
};
